<template>
    <div>
        <v-card elevation="0">
             <v-toolbar color="#ef6b01">
                <v-btn icon dark @click="atras"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                <v-card-title style="color:white" class="text-truncate">Forma de entrega</v-card-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="text-center mb-15 envio-content">
                <p v-if="opcionEnvio === null" class="mt-5" style="color:grey;font-size:17px">
                    Seleccione una forma de entrega
                </p>
                <v-row class="justify-center mt-5">
                    <v-btn-toggle v-model="opcionEnvio" background-color="orange">
                        <v-btn :disabled="!puedeEnvio"  text width="150" :color="(opcionEnvio==0)?'white':'orange'" :style="(opcionEnvio!=0)?'background-color: white;':''">envío</v-btn>
                        <v-btn :disabled="!puedeRetiro" text width="150" :color="(opcionEnvio==1)?'white':'orange'" :style="(opcionEnvio!=1)?'background-color: white;':''">retiro</v-btn>
                    </v-btn-toggle>
                </v-row>

                <div v-if="opcionEnvio==0" class="mt-10">
                    <h4 style="color:orange" class="letra">MIS DIRECCIONES</h4>
                    
                    <v-row class="mt-5">
                        <v-col cols="2" style="display: grid;    align-items: center;">
                            <v-icon color="orange" style="font-size:42px">mdi-map-marker</v-icon>
                        </v-col>
                        <v-col cols="10" style="text-align:initial">
                            <p class="mb-0 mt-0 p-0 text-h6" style="color:orange">Envio</p>
                            <p class="mb-0 mt-0 p-0 text-subtitle-1" v-if="cliente">{{cliente.DOM}}</p>
                            <p class="mb-0 mt-0 p-0 text-subtitle-1" v-if="cliente">{{`${cliente.LOCALIDAD} , ${cliente.PROVINCIA}`}} , Argentina</p>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-3 ml-3" style="border-top: ridge;width: 80%;display: inline-block;"></v-divider>
                    <v-row class="mt-5">
                        <v-col>
                            <v-select
                            class="ml-3 mr-3"
                            v-model="transporteSelected"
                            :items="transportesEnvio"
                            item-text="text"
                            item-value="value"
                            menu-props="auto"
                            label="Transporte"
                            prepend-icon="mdi-bus"
                            color="orange"
                            item-color="orange"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <template v-if="envioCliente && envioCliente.por_bulto=='N'">
                        <v-card v-if="envioCliente" :style="(costoFlete==0)?'background-color: #00d704':'background-color: #ffdcd7'">
                            
                            <v-row class="mt-5">
                                <!-- <v-col class="mt-2 mb-2" style="justify-content: end;display: flex;">
                                    <p :style="(costoFlete==0)?'color:#00a650':''" style="font-size:20px;font-weight: 600;margin:0px;padding:0px">Envío</p>
                                </v-col> -->
                                <v-col  class="mt-2 mb-2" style="justify-content: center;display: flex;">
                                
                                    <p v-if="precioConIva && costoFlete>0" style="font-size:20px;font-weight: 600;margin:0px;padding:0px">Envío: {{costoFlete | toCurrency}}<span style="font-size: 13px;"> más IVA (21%)</span></p>
                                    <p v-if="!precioConIva && costoFlete>0" style="font-size:20px;font-weight: 600;margin:0px;padding:0px">Envío: {{costoFlete | toCurrency}}</p>
                                    <p v-if="costoFlete==0" style="color:black;font-size:20px;font-weight: 600;margin:0px;padding:0px">Envío Gratis</p>
                                    
                                </v-col>
                            </v-row>
                        </v-card>
                    </template>
                </div>
                <div v-if="opcionEnvio==1" class="mt-10">
                    <h4 style="color:orange" class="letra">SUCURSALES</h4>
                    <v-row class="mt-5">
                        <v-col cols="2" style="display: grid;align-items: center;">
                            <v-icon color="orange" style="font-size:34px">mdi-basket</v-icon>
                        </v-col>
                        <v-col cols="10" style="text-align:initial;display: grid;align-items: end;">
                            <p class="mb-0 mt-0 p-0 text-h6">Deán J. Álvarez 262</p>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-3 ml-3" style="border-top: ridge;"></v-divider>
                    <div class="mt-10">
                        <v-row class="text-center justify-center">
                            <p class="letra mb-0 mt-0 p-0 text-h6" style="color:orange;">Horarios de Retiro</p>
                        </v-row>
                        <v-row style="justify-content: center;">
                            <v-radio-group v-model="horarioSelected" column style="min-width: 372px;">
                                <template v-for="(item,index) in horariosDeRetiro">
                                    <v-radio color="orange" :key="item.id" :value="item" class="mt-2 mb-2">
                                        <template v-slot:label>
                                            <v-row class="ml-1">
                                                <v-col>
                                                    <span>{{item.text}}</span>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-radio>
                                    <v-divider style="margin-left: 87px;" :key="index"></v-divider>
                                </template>
                            </v-radio-group>
                        </v-row>
                    </div>
                </div>

            </v-card-text>
            <!--FOOTER---------------->
            <v-footer color="#ef6b01" padless fixed outlined class="mt-5" style="height: 57px;">
                
                <v-row justify="center" no-gutters>
                    <v-col cols="4">
                    </v-col>
                    <v-col cols="4" class="text-center">
                        <v-btn style="bottom: 23px;" fab color="#ef6b01" elevation="20" @click="irVentas" class="my-2"><font-awesome-icon style="font-size:25px;color: white" icon="plus"/></v-btn>
                    </v-col>
                    <v-col cols="4" class="text-end">
                        <v-btn :disabled="bloquearSiguiente" small style="height: 54px;font-size: initial;" color="white" text elevation="0" @click="siguiente()">Siguiente<v-icon color="white">mdi-chevron-right</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-footer>
        </v-card>
        <!-- ----CARGANDO------- -->
        <v-overlay :value="cargando">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import ApiServer from '../api';
import {mapState, mapActions} from 'vuex';
export default {
    name:'Envio',
    data(){
        return{
            cliente:null,
            opcionEnvio:null,
            transportes:[],
            transporteSelected:null,
            horarioSelected:null,
            horariosDeRetiro:[],
            envioCliente:null,
            cargando:false
        }
    },
    methods:{
        ...mapActions(['editDatosCompra']),
        atras(){
            this.$router.go(-1)
        },
        irVentas(){
            this.$router.push({name: 'Home'});  
        },
        siguiente(){
            this.editDatosCompra(['tipoEnvio',(this.opcionEnvio==0)?'Envio':'Retiro'])
            this.editDatosCompra(['transporte', (this.opcionEnvio==0) ? this.transporteSelected : null])
            this.editDatosCompra(['horarioRetiro',this.horarioSelected])
            if(this.envioCliente && this.envioCliente.por_bulto == 'N'){
                if(this.precioConIva){
                    this.editDatosCompra(['costoFlete',this.costoFlete*(1.21)])
                }else{
                    this.editDatosCompra(['costoFlete',this.costoFlete])
                }
            }else{
                this.editDatosCompra(['costoFlete',null])
            }
            this.$router.push({name: 'Pago'});  
        }
    },
    async mounted(){
        if(this.usuario){
            this.cargando = true
            try {
               let respTransporte = await ApiServer.getTransportesCliente(this.usuario.cod_cli)
               respTransporte.forEach(item => {
                    this.transportes.push({
                        text: item.NOM_FANTASIA,
                        value: item.TRANS_ID
                    })
               });
               const envios = this.transportes.filter(t => t.text !== 'Pasa a retirar')
               const tienePasaARetirar = this.transportes.some(t => t.text === 'Pasa a retirar')
               if(envios.length === 0){
                   this.transporteSelected = null
                   this.opcionEnvio = 1
               } else if(tienePasaARetirar){
                   this.transporteSelected = null
                   this.opcionEnvio = null
               } else if(envios.length === 1){
                   this.transporteSelected = envios[0].value
                   this.opcionEnvio = 0
               } else {
                   this.transporteSelected = null
                   this.opcionEnvio = null
               }
                let result = await ApiServer.getDatosCliente(this.usuario.cod_cli)
                if(result.length>0){
                    let index = result.findIndex(x=>x.DOM_CLASIF_ID.trim()=='DE')
                    if(index>=0){
                        this.cliente = result[index]
                    }else{
                        this.cliente = result[0]
                    }
                }
                let resultEnvio = await ApiServer.getFleteCliente(this.usuario.cod_cli)
                if(resultEnvio.length>0)
                this.envioCliente = resultEnvio[0]

                let resultHorarios = await ApiServer.getHorariosRetiro()
                resultHorarios.forEach(item => {
                    this.horariosDeRetiro.push({text:item.descripcion,value:item.id})
                });
                this.cargando = false

                await ApiServer.postUsoLog({
                   cod_cli: this.usuario.cod_cli,
                   usuario: this.usuario.nombreUsuario,
                   accion: 'TIPO_DE_RETIRO',
                   dato: ''
               })
            } catch (error) {
                this.cargando = false
                console.log(error);
            }
        }
    },
    computed:{
        ...mapState(['usuario','carrito']),
        tienePasaARetirar(){
            return this.transportes.some(t => t.text === 'Pasa a retirar')
        },
        transportesEnvio(){
            return this.transportes.filter(t => t.text !== 'Pasa a retirar')
        },
        puedeEnvio(){
            return this.transportesEnvio.length > 0
        },
        puedeRetiro(){
            return this.transportes.length === 0 || this.tienePasaARetirar
        },
        bloquearSiguiente(){
            if(this.opcionEnvio === null){
                return true
            }
            if(this.opcionEnvio==0){//ENVIO
                if(!this.transporteSelected){
                    return true
                }else{
                    return false
                }
            }else{//RETIRO
                if(!this.horarioSelected){
                    return true
                }else{
                    return false
                }
            }
        },
        precioConIva(){
            if(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI'){
                return true
            }else{
                return false
            }
        },
        total(){
            let total=0
            if(this.carrito.length>0){
                this.carrito.forEach(item => {
                    let empaque = (item.cant_empaq!=0)? item.cant_empaq : 1 
                    total+=(item.pr_final + item.pr_final*(item.descuento/100)) * empaque * item.cantidad
                });
            }
            return total
        },
        totalSinIva(){
            let total=0
            if(this.carrito.length>0){
                this.carrito.forEach(item => {
                    let empaque = (item.cant_empaq!=0)? item.cant_empaq : 1 
                    total+=(item.pr_vta + item.pr_vta*(item.descuento/100)) * empaque * item.cantidad
                });
            }
            return total
        },
        costoFlete(){
            let total = (this.precioConIva)?this.totalSinIva:this.total
            if(this.envioCliente ){
                if(this.envioCliente.por_bulto == 'S'){
                    if(this.precioConIva){//LE AGREGO "más IVA" en la descripcion
                        return this.envioCliente.MontoMinimo * this.productos
                    }else{
                        return this.envioCliente.MontoMinimo * this.productos * (1.21)
                    }
                }else{
                    // let minimo = (this.envioCliente.MontoMinimo/this.envioCliente.Porcentaje)*100
                    let minimo =  this.envioCliente.compra_minima
                    if(total>=minimo){
                        return 0.00
                    }else{
                        if(this.precioConIva){//LE AGREGO "más IVA" en la descripcion
                            return this.envioCliente.MontoMinimo
                        }else{
                            return (this.envioCliente.MontoMinimo*1.21)
                        }
                    }
                }
            // }else if(this.envioCliente){
            //     let minimo = (this.envioCliente.MontoMinimo/this.envioCliente.Porcentaje)*100
            //     if(total>=minimo){
            //         return total*(this.envioCliente.Porcentaje/100)
            //     }else{
            //         if(this.precioConIva){//LE AGREGO "más IVA" en la descripcion
            //             return this.envioCliente.MontoMinimo
            //         }else{
            //             return (this.envioCliente.MontoMinimo*1.21)
            //         }
            //     }
            }else{
                return 0
            }
        },
        productos(){
            let cant=0
            if(this.carrito.length>0){
                this.carrito.forEach(item => {
                    cant+=parseInt(item.cantidad)
                });
                return cant
            }else if(isNaN(cant)){
                return 0
            }else{
                return cant
            }
        },
    },
    watch:{
        opcionEnvio(val){
            if(val === 0 && this.transportesEnvio.length === 1){
                this.transporteSelected = this.transportesEnvio[0].value
            }
        }
    }
}
</script>

<style scoped>
    .letra{
        font-family: sans-serif;
        letter-spacing: 1px;
    }

    .envio-content {
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
    }

    @media (min-width: 960px) {
        .envio-content .v-row.mt-5 {
            margin-top: 12px !important;
        }
        .envio-content .mt-10 {
            margin-top: 24px !important;
        }
    }
</style>